export const servicesResources = {
    en: {
        Title: "Our Services",
        Intro:
            "We deliver end-to-end finance services designed to reduce complexity, enhance transparency, and enable confident, data-driven decision-making. Our integrated finance solutions combine operational excellence, strategic insight, and scalable execution—allowing organizations to grow efficiently, strengthen governance, and adapt seamlessly as business needs evolve.",

        Includes: "Services Include",
        Outcomes: "Outcomes",

        BPO: {
            Title: "Financial BPO Services",
            Overview:
                "We manage your finance back office with precision and discipline, ensuring day-to-day financial operations are accurate, compliant, and reliable—so leadership teams can focus on scaling the business.",
            Services: [
                "Bookkeeping & General Ledger Management",
                "Accounts Payable & Accounts Receivable",
                "Payroll Processing",
                "Month-End and Year-End Closing",
                "Management Information System (MIS) Reporting",
                "Compliance, Audit & Regulatory Support",
                "Expense Control and Vendor Management"
            ],
            Outcomes: [
                "Accurate and audit-ready financial records",
                "Faster and more predictable month-end close",
                "Stronger internal controls",
                "Lower finance operating costs",
                "Reduced financial and operational risk"
            ],
            CTA: "Request a BPO Proposal"
        },

        FPA: {
            Title: "FP&A Outsourcing",
            Overview:
                "We provide comprehensive FP&A capabilities—from budgeting and forecasting to advanced analytics—equipping leadership with forward-looking insights to drive performance and strategic alignment.",
            Services: [
                "Annual Budgeting and Strategic Planning",
                "Rolling Forecasts and Reforecasting",
                "Profitability and Margin Analysis",
                "Cash Flow Modeling and Liquidity Planning",
                "KPI Dashboards (Power BI / Tableau)",
                "Scenario and Sensitivity Analysis",
                "Cost Optimization and Driver-Based Planning",
                "Board and Investor Reporting Packages"
            ],
            Outcomes: [
                "Improved strategic and operational decisions",
                "Reduced forecast variance",
                "Clear financial visibility across the business",
                "Performance-driven management culture"
            ],
            CTA: "Explore FP&A Solutions"
        },

        CFO: {
            Title: "Fractional CFO Services",
            Overview:
                "Our fractional CFO offering delivers senior-level financial leadership on a part-time or on-demand basis, tailored to the needs of growing and scaling companies seeking expertise without the cost of a full-time executive.",
            Services: [
                "Strategic financial planning",
                "Fundraising and investor management",
                "Capital allocation and cash management",
                "Profitability improvement initiatives",
                "Mergers and acquisitions support",
                "Financial controls and risk management",
                "Growth planning and business model redesign"
            ],
            Outcomes: [
                "Access to senior leadership without full-time cost",
                "Strong and cohesive financial strategy",
                "Improved investor confidence",
                "Faster growth with better governance"
            ],
            CTA: "Talk to a Fractional CFO"
        }
    },

    ar: {
        Title: "خدماتنا",
        Intro:
            "نقدم خدمات مالية متكاملة تقلل التعقيد، وتعزز الشفافية، وتمكّن اتخاذ قرارات مبنية على البيانات بثقة. تجمع حلولنا بين التميز التشغيلي والرؤية الاستراتيجية والتنفيذ القابل للتوسع لدعم النمو المستدام وتعزيز الحوكمة.",

        Includes: "تشمل الخدمات",
        Outcomes: "النتائج",

        BPO: {
            Title: "خدمات التعهيد المالي",
            Overview:
                "ندير العمليات المالية الخلفية بدقة وانضباط لضمان دقة العمليات اليومية والامتثال، مما يتيح للإدارة التركيز على نمو الأعمال.",
            Services: [
                "مسك الدفاتر وإدارة الأستاذ العام",
                "الحسابات الدائنة والمدينة",
                "إدارة الرواتب",
                "إغلاق نهاية الشهر والسنة",
                "تقارير المعلومات الإدارية",
                "الامتثال والدعم التدقيقي والتنظيمي",
                "إدارة المصروفات والموردين"
            ],
            Outcomes: [
                "سجلات مالية دقيقة وجاهزة للتدقيق",
                "إغلاق مالي أسرع وأكثر انتظامًا",
                "تعزيز الضوابط الداخلية",
                "خفض تكاليف التشغيل المالية",
                "تقليل المخاطر المالية والتشغيلية"
            ],
            CTA: "طلب عرض تعهيد مالي"
        },

        FPA: {
            Title: "خدمات FP&A",
            Overview:
                "نوفر قدرات تخطيط وتحليل مالي متقدمة تمكّن الإدارة من فهم الأداء المستقبلي واتخاذ قرارات استراتيجية مدروسة.",
            Services: [
                "إعداد الميزانية والتخطيط الاستراتيجي",
                "التنبؤات الدورية",
                "تحليل الربحية",
                "نمذجة التدفقات النقدية",
                "لوحات مؤشرات الأداء",
                "تحليل السيناريوهات",
                "تحسين التكاليف",
                "تقارير مجلس الإدارة"
            ],
            Outcomes: [
                "تحسين جودة القرارات",
                "تقليل انحراف التوقعات",
                "رؤية مالية واضحة",
                "ثقافة إدارية قائمة على الأداء"
            ],
            CTA: "استكشاف حلول FP&A"
        },

        CFO: {
            Title: "خدمات المدير المالي الجزئي",
            Overview:
                "نقدم قيادة مالية تنفيذية بدوام جزئي أو عند الطلب، مصممة لدعم الشركات في مراحل النمو دون تكلفة مدير مالي بدوام كامل.",
            Services: [
                "التخطيط المالي الاستراتيجي",
                "إدارة المستثمرين وجمع التمويل",
                "إدارة رأس المال والتدفقات النقدية",
                "تحسين الربحية",
                "دعم عمليات الاندماج والاستحواذ",
                "الضوابط المالية وإدارة المخاطر",
                "التخطيط للنمو وإعادة تصميم نموذج الأعمال"
            ],
            Outcomes: [
                "قيادة مالية رفيعة المستوى بتكلفة أقل",
                "استراتيجية مالية قوية",
                "زيادة ثقة المستثمرين",
                "نمو أسرع وحوكمة أفضل"
            ],
            CTA: "التحدث إلى مدير مالي جزئي"
        }
    }
};
